import React from 'react';
import Close from '@mui/icons-material/Close';
import {
  Box,
  Divider,
  Grid,
  GridProps,
  IconButton,
  SvgIcon,
  Typography,
} from '@mui/material';
import PluginConnectionItem from './PluginConnectionItem';
import { SparkButton } from 'sharedComponents/UI';
import { PlusIcon } from 'components/SVG';
import type { PluginConnections } from 'types/PluginConnections';
import { useIsConnectionValid } from './utils';

type PluginConnectionPopupProps = {
  onClose: () => void;
  sx?: GridProps['sx'];
  pluginConnections: PluginConnections[] | undefined;
  onConnectionItemClick: (connectionID: string) => void;
  onAddClick: () => void;
};

function PluginConnectionPopup({
  onClose,
  sx,
  pluginConnections,
  onAddClick,
  onConnectionItemClick,
}: PluginConnectionPopupProps) {
  const checkConnectionValidity = useIsConnectionValid();

  return (
    <Grid
      display='flex'
      flexDirection='column'
      width='100%'
      borderRadius='10px'
      sx={{
        background: 'white',
        boxShadow:
          'rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;',
        ...sx,
      }}
    >
      <Grid
        container
        padding={1.5}
        sx={{
          borderColor: (theme) => theme.palette.borderColor,
        }}
      >
        <Grid
          item
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          mb={2}
          width='inherit'
        >
          <Typography
            sx={{
              fontFamily: 'mont-semibold',
            }}
          >
            Select Connection
          </Typography>
          <IconButton onClick={onClose}>
            <Close
              sx={{
                width: '24px',
                height: '24px',
                color: 'black',
              }}
            />
          </IconButton>
        </Grid>
        <Grid container>
          <Grid container gap={0.3} maxHeight='300px' overflow='auto'>
            {pluginConnections?.map((connection, index) => (
              <React.Fragment key={index}>
                <PluginConnectionItem
                  pluginConnection={connection}
                  onClick={() => onConnectionItemClick(connection.id)}
                  isActive={checkConnectionValidity(
                    connection?.attributes.pluginConnectionStatusTypeID
                  )}
                />

                {pluginConnections?.length - 1 !== index && (
                  <Box width='100%'>
                    <Divider />
                  </Box>
                )}
              </React.Fragment>
            ))}
          </Grid>
          <SparkButton
            onClick={onAddClick}
            variant='contained'
            startIcon={
              <SvgIcon
                sx={{
                  '& path': {
                    fill: 'white',
                  },
                  stroke: 'white',
                }}
              >
                <PlusIcon color='white' width='22' height='22' />
              </SvgIcon>
            }
            sx={{ width: '100%', marginTop: 1, padding: '10px 20px' }}
          >
            Add Connection
          </SparkButton>
        </Grid>
      </Grid>
    </Grid>
  );
}
export default PluginConnectionPopup;
